
require 'plugins/pure/pure-min.css'

require 'plugins/flexslider/flexslider.css'
require 'plugins/slick-carousel/slick/slick.css'
require 'plugins/sweetalert/lib/sweet-alert.css'
require 'plugins/swiper/dist/css/swiper.min.css'
require 'styles/common/util.scss'
require 'styles/common/common1.scss'
require 'styles/common/baoming.scss'
require 'plugins/slide/index.css'
require 'plugins/slide/slide.css'
require 'plugins/icomoon/style.css'
require 'styles/pages/praise-index.scss'

require 'script!jquery'
require 'script!flexslider'
require 'script!affix'
require '../common/form-validation.coffee'
require 'script!ajaxform'
require 'script!flexslider'
require 'script!plugins/scrollspy.js'
require 'script!plugins/swiper/dist/js/swiper.jquery.js'
require 'script!plugins/slide/slide.min.js'
require '../common/city.coffee'

# 设计部分js
do ->
  if $('#design').length > 0
    $form1 = $('#design')
    # $houseDecorateArea1 = $form1.find '[name="houseDecorateArea"]'
    $mobile1 = $form1.find '[name="mobile"]'
    $area1 = $form1.find '[name="area"]'
    # $truename1 = $form1.find '[name="truename"]'
    $shi1 = $form1.find '[name="shi"]'
    $ting1 = $form1.find '[name="ting"]'
    $wei1 = $form1.find '[name="wei"]'
    $yangtai1 = $form1.find '[name="yangtai"]'
    $dl = $form1.find '[name="dl"]'
    $agreement = $form1.find '[name = agreement]'

    # 表单验证
    $form1.validate
      errorPlacement: (error, element)->
        swal {
          title: error[0].innerHTML
          allowOutsideClick: false
        }
      submitHandler: (form)->
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"

        $(form).ajaxSubmit {
          dataType: 'json'
          data: {
            rnd: parseInt(Math.random()*1e7,10)+(new Date()).getTime()
          }
          error: ->
            swal {
              title: '对不起，出错了，请稍后重试！'
              allowOutsideClick: true
            }
          success: (res)->
            if res.msg?[0]?.type is 'success'
              window._agl and window._agl.push(['track', ['success', {t: 3}]])
              if $dl.val()
                swal({
                  title: '您的信息已提交成功，请注意短信查收报价结果',
                  allowOutsideClick: true
                })
              else
                swal({
                  customClass: 'alert-success',
                  title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
                  confirmButtonText: '返  回',
                  confirmButtonColor: '#3b9bff',
                  allowOutsideClick: true,
                  html: true,
                  timer:1000000
                })
            if res.msg[0].type is 'error'
              swal {
                title: res.msg[0].info
                allowOutsideClick: true
              }
              return false
        }
        return false

    if $agreement.length
      $agreement.rules 'add',{
        required: true
        messages: {
          required: '请勾选已阅读并同意积木家的用户协议'
        }
      }
    
    # if $houseDecorateArea1.length
    #   $houseDecorateArea1.rules 'add',
    #     required: true
    #     messages:
    #       required: '请填写房屋所在城市'

    if $area1.length
      $area1.rules 'add',
        required: true
        messages:
          required: '请输入房屋面积'

    # if $truename1.length
    #   $truename1.rules 'add',
    #     required: true
    #     messages:
    #       required: '请输入您的姓名'

    if $shi1.length
      $shi1.rules 'add',
        required: true
        messages:
          required: '请选择您家卧室个数'

    if $ting1.length
      $ting1.rules 'add',
        required: true
        messages:
          required: '请输入您家客厅个数'

    if $wei1.length
      $wei1.rules 'add',
        required: true
        messages:
          required: '请选择您家卫生间个数'

    if $yangtai1.length
      $yangtai1.rules 'add',
        required: true
        messages:
          required: '请选择您家阳台个数'

    if $mobile1.length
      $mobile1.rules 'add',
        required: true
        mobileNum: true
        messages:
          required: '请输入11位手机号码'
          mobileNum: '请输入正确的手机号'

# 报价部分js
do ->
  if $('#footerbaojia').length > 0
    $form = $('#footerbaojia')
    $area = $form.find '[name="area"]'
    # $truename = $form.find '[name="truename"]'
    $mobile = $form.find '[name="mobile"]'
    $dl = $form.find '[name="dl"]'
    $agreement = $form.find '[name = agreement]'

    # 表单验证
    $form.validate
      errorPlacement: (error, element)->
        swal {
          title: error[0].innerHTML
          allowOutsideClick: false
        }
      submitHandler: (form)->
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"

        $(form).ajaxSubmit {
          dataType: 'json'
          data: {
            rnd: parseInt(Math.random()*1e7,10)+(new Date()).getTime()
          }
          error: ->
            swal {
              title: '对不起，出错了，请稍后重试！'
              allowOutsideClick: true
            }
          success: (res)->
            if res.msg?[0]?.type is 'success'
              window._agl and window._agl.push(['track', ['success', {t: 3}]])
              if $dl.val()
                swal({
                  title: '您的信息已提交成功，请注意短信查收报价结果!',
                  allowOutsideClick: true
                })
              else
                swal({
                  customClass: 'alert-success',
                  title: '<img class="form_success" src="http://p.51zx.com/FuK_TJTSwVZBR7Ho2nAj1_z3THKw" alt="">',
                  confirmButtonText: '返  回',
                  confirmButtonColor: '#3b9bff',
                  allowOutsideClick: true,
                  html: true,
                  timer:1000000
                })
            if res.msg[0].type is 'error'
              swal {
                title: res.msg[0].info
                allowOutsideClick: true
              }
              return false
        }
        return false

    if $agreement.length
      $agreement.rules 'add',{
        required: true
        messages: {
          required: '请勾选已阅读并同意积木家的用户协议'
        }
      }

    if $area.length
      $area.rules 'add',
        required: true
        messages:
          required: '请输入装修面积'

    # if $truename.length
    #   $truename.rules 'add',
    #     required: true
    #     messages:
    #       required: '请输入您姓名'

    if $mobile.length
      $mobile.rules 'add',
        required: true
        mobileNum: true
        messages:
          required: '请输入11位手机号码'
          mobileNum: '请输入正确的手机号'
do->
  $yuyuefix = $('.yuyuefix')
  $yuyuefix_close = $yuyuefix.find '.fix_close'
  $yuyuefix_close.on 'click', (evt)->
    evt.preventDefault()
    $yuyuefix.animate({bottom : -100})



/** WEBPACK FOOTER **
 ** /root/workspace/jimujia-pc_4ez23/wwwroot/static/~/coffeelint-loader!./praise-index.coffee
 **/